//
//
//
//
//
//
//
//
//
export default {
  name: 'OilpsiManage',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created oilpsiManage');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated oilpsiManage');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};